<template>
  <div class="avatar-wrap">
    <img class="user-avatar" :src="userAvatar" />
    <el-dropdown
      trigger="click"
      placement="top-end"
      @command="handleCommand"
      @visible-change="dropdownClick"
    >
      <span class="username">
        {{ username }}
        <i
          :class="[
            dropdownVisible ? 'icon-nav-user-fold' : 'icon-nav-user-unfold',
          ]"
        />
      </span>

      <el-dropdown-menu slot="dropdown" class="popup-menu">
        <el-dropdown-item command="personalInfo">
          <div class="el-dropdown icon-item">
            <i class="iconfont icon-bpm--addressbook" />
            <span>{{ $t('eip.nav.personalInformation') }}</span>
          </div>
        </el-dropdown-item>

        <el-dropdown-item>
          <el-dropdown placement="left-start" @command="handleLangChange">
            <div class="icon-item switch-lang">
              <i class="iconfont icon-bpm--Exportservices" />
              <span>{{ $t('eip.nav.switchLanguage') }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="lang in $LANGUAGES"
                :key="lang.type"
                :command="lang.type"
              >
                <div
                  :class="[
                    'sub-dropdown-menu',
                    { active: lang.type === $i18n.locale },
                  ]"
                >
                  <div style="width: 60px">{{ lang.desc }}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-dropdown-item>
        <el-dropdown-item
          id="login-out"
          command="logout"
          class="dropdown-menu__item--logout"
        >
          <div class="user-logout icon-item">
            <span>{{ $t('eip.nav.logOut') }}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 个人信息 dialog -->
    <personal-info
      :account-info="accountInfo"
      :personal-info-visible.sync="personalInfoVisible"
    />
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import { getDetailByAccountOrId } from '@/api/user'
  import variables from '@/styles/variables.scss'
  import PersonalInfo from '../PersonalInfo'
  import req from '@/utils/request'
  import svg from '@/assets/navbar_svg'

  export default {
    name: 'HtAvatar',
    components: {
      PersonalInfo,
    },
    data() {
      return {
        svg,
        postMap: {},
        defaultPost: {},
        orgArray: [],
        accountInfo: null,
        dropdownVisible: false,
        personalInfoVisible: false,
        imgSrc: '',
        defaultimgSrc: require('@/assets/images/default_avatar.png'),
      }
    },
    computed: {
      ...mapGetters({
        avatar: 'user/avatar',
        username: 'user/username',
        style: 'settings/style',
        account: 'user/account',
      }),
      userAvatar() {
        return this.avatar || this.defaultimgSrc
      },
      variables() {
        return variables
      },
      hasPost() {
        return Object.keys(this.postMap).length > 0
      },
      postInfo() {
        if (this.hasPost) {
          return `${this.defaultPost.postName}(${this.defaultPost.orgName})`
        }
        return this.$t('eip.nav.noPositionAvailable')
      },
    },
    methods: {
      ...mapMutations('tabsBar', ['delAllVisitedRoutes']),
      // 下拉菜单显示，请求用户详细信息
      dropdownClick(isVisible) {
        this.dropdownVisible = isVisible
        if (isVisible && !this.accountInfo) {
          if (!this.account) return
          getDetailByAccountOrId(this.account).then((data) => {
            if (data) {
              this.accountInfo = data
              this.postMap = data.post || {}
              this.orgArray = data.org || []
              for (let key in this.postMap) {
                this.postMap[key].selected = false
              }
              const postId = sessionStorage.getItem('currentPostId')
              if (postId) {
                this.setDefaultPost(postId)
              } else {
                if (this.orgArray.length) {
                  this.setDefaultPost(this.orgArray[0].postId)
                }
              }
            }
          })
        }
      },
      handleLangChange(lang) {
        this.handleSetLanguage(lang)
      },
      handlePostChange(post) {
        if (!post) return
        const postId = post.postId
        this.setDefaultPost(postId)
        this.$message.success(this.$t('eip.nav.switchPositionsSuccess'))
        sessionStorage.setItem('currentPostId', postId)
        req.get(window.context.uc + '/uc/ucGroup/v1/setCookie?postId=' + postId)
        this.$router.go(0)
      },
      setDefaultPost(postId) {
        for (let key in this.postMap) {
          if (this.postMap[key].postId === postId) {
            this.defaultPost = this.postMap[key]
            this.postMap[key].selected = true
          } else {
            this.postMap[key].selected = false
          }
        }
      },
      handleCommand(command) {
        switch (command) {
          case 'personalInfo':
            this.personalInfoVisible = true
            break
          case 'logout':
            this.logoutWithTips()
            break
        }
      },
      async handleSetLanguage(lang) {
        if (lang === this.$i18n.locale) return
        location.reload()
      },
      logoutWithTips() {
        const tips = this.$t('eip.nav.logOutConfirm', { name: this.$baseTitle })
        this.$baseConfirm(tips, null, async () => {
          await this.$store.dispatch('user/logout')
          this.delAllVisitedRoutes()
          // 单点登录模式下重定向到单点退出页面
          this.$store.dispatch('user/toLoginUrl')
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .el-dropdown-menu {
    padding: 0 !important;
    border-radius: 8px;

    ::v-deep .popper__arrow {
      display: none;
    }

    #login-out {
      &:hover {
        background: unset !important;
      }
    }

    .el-dropdown-menu__item {
      padding: 0 14px;
      line-height: 1;

      .el-dropdown,
      .sub-dropdown-menu {
        padding: 10px 0;
        border-bottom: 1px solid #ececec;
      }

      .icon-item {
        color: #5f737f;
        &:hover {
          color: #0560fd;
        }
        i {
          display: inline-block;
          margin-right: 10px;
          vertical-align: middle;
        }
        span {
          display: inline-block;
          vertical-align: middle;
        }
      }

      &:hover {
        background-color: #eaf3ff !important;
      }
    }

    .dropdown-menu__item--logout {
      padding: 10px 14px;
      font-size: 12px;
      text-align: center;

      .user-logout {
        width: 100%;
        padding: 7px 0;
        color: #f5603f;
        background: #ffece8;
        border-radius: 4px;

        &:hover {
          color: #f5603f;
          outline: 1px solid #ffcabe;
        }
      }
    }
  }

  .user-avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
  }

  .avatar-wrap {
    display: flex;
    align-items: center;
    cursor: pointer;
    .username {
      margin: 0 8px;
      color: #000000;
    }
  }

  .account-info {
    display: flex;
    padding: 8px 16px;
    margin-bottom: 3px;

    .flex-right {
      margin-left: 8px;

      .user-name {
        color: $base-font-color;
      }

      .position {
        max-width: 110px;
        padding: 6px;
        margin-top: 5px;
        overflow: hidden;
        font-size: $base-font-size-small;
        color: var(--themeColor);
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: rgba(var(--themeColorRgb), 0.08);
        border-radius: $base-border-radius;
      }
    }
  }

  .switch-lang,
  .switch-position {
    width: 100%;

    &:hover {
      color: #0560fd;
    }
  }

  .active {
    color: var(--themeColor);
  }

  .sub-dropdown-menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 0;
  }
</style>
